import { ChangeDetectionStrategy, Component, Output, EventEmitter, inject, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SlideInRightModalComponent } from '@app/shared/ui/slide-in-right-modal/slide-in-right-modal.component';
import { ProductService } from '@app/core/services/client/product.service';
import { LoadingService } from '@app/core/services/loading.service';
import { Observable, Subscription } from 'rxjs';
import { IBillsProduct } from '@app/core/models/client/products/products.model';
import { PortfolioOrderComponent } from '../portfolio-order/portfolio-order.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'app-commercial-papers',
  standalone: true,
  imports: [
    CommonModule,
    SlideInRightModalComponent,
    PortfolioOrderComponent,
    NgxSkeletonLoaderModule
  ],
  templateUrl: './commercial-papers.component.html',
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CommercialPapersComponent {
  @Output() action = new EventEmitter<string>();

  productService = inject(ProductService);
  loadingService = inject(LoadingService);
  change = inject(ChangeDetectorRef);

  returnPathUrl!: string;
  subs: Subscription[] = [];
  commercialPapers: IBillsProduct[] = [];
  isProductOrderModalOpen: boolean = false;
  selectedCommercialPaper!: IBillsProduct; 
  isFetchingCommercialPaper$: Observable<boolean>;



  
  closeModal(): void {
    this.action.emit();
  }

  ngOnInit() {
    this.getCommercialPaperProducts();
  }

  constructor() {
    this.isFetchingCommercialPaper$ = this.loadingService.getLoadingObservable('get-commercial-paper');
  }

  getCommercialPaperProducts() {
    this.loadingService.setLoading('get-commercial-paper', true);
    const sub = this.productService.getCommercialPaperProducts().subscribe({
      next: (res) => {

        this.commercialPapers = res.data.data;
        this.change.detectChanges();

        this.loadingService.setLoading('get-commercial-paper', false);
      },
      error: (err) => {
        this.loadingService.setLoading('get-commercial-paper', false);
        this.change.detectChanges();

      }
    });
    this.subs.push(sub);
  }

  toggleCommercialPaper(commercialPaper: IBillsProduct) {
    this.selectedCommercialPaper = commercialPaper;
    this.toggleProductOrder();
    
  }

  toggleProductOrder() {
    this.isProductOrderModalOpen = !this.isProductOrderModalOpen;
  }

  ngOnDestroy(): void {
    this.subs.forEach(sub => sub.unsubscribe());
  }

}
